import classes from './scroll-area.module.css'

const ScrollArea = {
  classNames: {
    thumb: classes.thumb,
    scrollbar: classes.scrollbar,
  },
}

export default ScrollArea
